const {Component} = window.wp.element;
const {__} = window.wp.i18n;
const { TextControl, SelectControl } = window.wp.components;

class WiFormSettings extends Component
{
	constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this)

        this.state = {
        	fields: {
	            btn_text: __('Submit', 'webinane-forms'),
	            action: 'email',
	            btn_class: 'btn btn-primary'
	        },
	        isLoaded: false,
	        error: null
        };
    }
    componentDidMount() {

    	let post_id = document.getElementById('post_ID').value

    	fetch(ajaxurl+'?action=wif_get_settings', {
    		method: 'POST',
    		body: JSON.stringify({
    			id: post_id
    		})
    	})
    	.then(res => res.json())
    	.then(
    		(result) => {

    			if(result.message) {
	    			this.setState({
	    				isLoaded: true,
	    				fields: result.data
	    			});
    			}
    		},
	        // Note: it's important to handle errors here
	        // instead of a catch() block so that we don't swallow
	        // exceptions from actual bugs in components.
	        (error) => {
	        	this.setState({
	        		isLoaded: true,
	        		error
	        	});
	        }
	    )
    }
    handleChange(name, value) {

    	const {jQuery, ajax} = window
    	let post_id = document.getElementById('post_ID').value
    	let fields = {...this.state.fields}
    	fields[name] = value

    	this.setState({fields: fields})

    	jQuery.ajax({
    		url: ajaxurl,
    		type: 'post',
    		data: {action: 'wif_save_settings', id: post_id, data: this.state.fields },
    		success: (res) => {

    		}
    	})
    }
    render() {
    	const {action, btn_text, btn_class} = this.state.fields;

        return (
            <div className="wif-form-settings">

            	<SelectControl 
            		label={__('Form Action')}
            		value={action}
            		options={ [
			            { label: 'Email', value: 'email' },
			            { label: 'Show in Admin', value: 'database' },
			        ] }
            		help={__('Choose where to submit form, email, database etc', 'webinane-forms')}
            		onChange={(value) => {this.handleChange('action', value) }}
            	/>
            	<TextControl 
            		label={__('Submit Button Text')}
            		value={btn_text}
            		onChange={(value) => {this.handleChange('btn_text', value) }}
            		help={__('Enter the text to show in button', 'webinane-forms')}
            	/>
            	<TextControl 
            		label={__('Submit Button Class')}
            		value={btn_class}
            		onChange={(value) => {this.handleChange('btn_class', value) }}
            		help={__('Enter the css class to show in button', 'webinane-forms')}
            	/>
            	
            </div>
        )
    }
}


export default WiFormSettings;